__turbopack_context__.v({
  "desktopHeader": "AppShell-module__x97y7q__desktopHeader",
  "logoutButton": "AppShell-module__x97y7q__logoutButton",
  "main": "AppShell-module__x97y7q__main",
  "mainContent": "AppShell-module__x97y7q__mainContent",
  "shell": "AppShell-module__x97y7q__shell",
});
